const fullTextSearchRouter = () => {
    return [
        {
            path: 'search-v',
            name: 'search-v',
            component: () => import(/* webpackChunkName: "home" */'../../modules/full-text-search/index.vue')
        }
    ];
};
export default fullTextSearchRouter;
